if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }
    
    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}


function addProductToCart(variantId){
	let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1
      }]
    };
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}


var addToCartButtons = document.querySelectorAll(".add-to-card-wrapper > a");
addToCartButtons.forEach((btn) => {
	btn.addEventListener("click", (e) => {
      e.preventDefault();
      if(e.currentTarget.classList.contains("no-variations")){
        var variantId = e.currentTarget.dataset.variantId;
		e.target.parentNode.classList.add("success");                     
        addProductToCart(variantId)
        setTimeout(function(){
			e.target.parentNode.classList.remove("success");
	    }, 1200)
      } else {
      	e.currentTarget.parentNode.classList.add("active");
      }
	})
});

var addToCardVariantCloseButtons = document.querySelectorAll(".add-to-card-variant-close");
addToCardVariantCloseButtons.forEach((closeBtn) => {
  closeBtn.addEventListener("click", (e) => {
  	e.preventDefault();
    var container = e.target.closest(".add-to-card-wrapper");
    container.classList.remove("active");  
  });
});

var addToCartVariants = document.querySelectorAll(".add-to-card-variant-selector a[data-variant-id]");
addToCartVariants.forEach((variant) => {
  variant.addEventListener("click", (e) => {
      e.preventDefault();
	  var variantId = e.currentTarget.dataset.variantId;
      addProductToCart(variantId);
      var container = e.target.closest(".add-to-card-wrapper");
      container.classList.remove("active");  
	  container.classList.add("success"); 
      setTimeout(function(){
		container.classList.remove("success");
      }, 1200)
  });
});
